import React from "react";
import {Alert, Container} from "react-bootstrap";
import "./covid-alert.scss"

export default function CovidAlert() {
    return <Alert variant="secondary" className="m-0">
        <Container>
            <div style={{textAlign:"center",color:"red"}}>
                We are currently not accepting book proposals/manuscripts for publication. Please do not send submissions or inquiries regarding book proposals. 
                <br/>
                If you are interested in our Journals publishing program under Spectrum, please mail us at <a href="mailto:spectrum.jps@sagepub.in">spectrum.jps@sagepub.in</a>
            </div>

        </Container>
    </Alert>
}
